<template>
    <modal height="auto" width="90%" :scrollable="true" @opened="onOpen" @closed="onHidden" name="visit-log" classes="modal_default" :clickToClose="true">
    <div class="card" :data-testid="'client-visit-log-' + visitId + '-dialog'">
        <div class="card-header">
            Historie úprav návštěvy
        </div>
        <div class="card-body" v-if="logVisit.length > 0 && logVisitPending !== true">
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th scope="col">verze</th>
                        <th scope="col">akce</th>
                        <th scope="col">změna</th>
                        <th scope="col">provedl</th>
                        <th scope="col">datum a čas</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="log in logVisit">
                        <td>{{ log.version }}</td>
                        <td>{{ log.action }}</td>
                        <td>
                            <template v-for="(value, key) in log.data">
                                <span><i>{{ key }}</i>: <b>{{ value }}</b></span><br>
                            </template>
                        </td>
                        <td>{{ log.username }}</td>
                        <td>{{ log.logged_at }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="card-body" v-if="logVisit.length < 1 && logVisitPending !== true">
            návštěva bez historie
        </div>
    </div>
    </modal>
</template>

<script>
  import apiMixin from '@/mixins'

  export default {
    data () {
      return {
        modalOpened: false,
        logVisit: false,
        logVisitPending: true,
        logVisitError: false
      }
    },
    props: ['opened', 'visitId'],
    mixins: [apiMixin],
    methods: {
      onHidden () {
        // this.opened = false
      },
      onOpen () {
        this.init()
        this.getlogVisit(this.visitId)
      },
      getlogVisit (visitId) {
        this.logVisitPending = true
        this.$http.get('log_visit/' + visitId).then(response => {
          this.logVisit = response.data
          this.logVisitPending = false
        }, response => {
          this.logVisitError = response.body.error
          this.logVisitPending = false
        })
      },
      init () {
        this.logVisit = false
        this.logVisitPending = false
        this.logVisitError = false
      }
    },
    watch: {
      opened (val) {
        if (val === true) {
          // console.log('otevreno')
        }
      },
      '$route' (to, from) {
        if (to.params.visitId !== from.params.visitId && typeof (to.params.visitId) !== 'undefined') {
          // this.init()
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h1, h2 {
        font-weight: normal;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }

    @media screen
    {
        .noPrint{}
        .noScreen{display:none;}
    }

    @media print
    {
        .noPrint{display:none;}
        .noScreen{}
    }


</style>



// WEBPACK FOOTER //
// src/views/Client/modals/VisitLog.vue?6269af62